/** API route map: URLS.Controller.ReferenceCheckRequest */
export const ReferenceCheckRequest = {
      Name: 'ReferenceCheckRequest/',
      FetchReferenceCheckRequestData: 'fetch-reference-check-request-data',
      SubmitReferenceCheckQuestionnaire: 'submit-reference-check-questionnaire',
      SendReferenceCheckQuestionnaire: 'send-reference-check-questionnaire',
      SendReferenceCheckQuestionnaireBulkAction: 'send-reference-check-questionnaire-bulk',
};
